(function ($) {
  'use strict';

  var config = {};
  var upsellRequestId = 0;

  function readConfig() {
    var node = document.getElementById('SmCartDrawerConfig');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  }

  function formatMoney(cents) {
    var format = config.moneyFormat || window.default_currency_format;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && format) {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function replaceTokens(template, tokens) {
    var output = template || '';
    Object.keys(tokens).forEach(function (key) {
      output = output.split('{{ ' + key + ' }}').join(tokens[key]);
      output = output.split('{{' + key + '}}').join(tokens[key]);
    });
    return output;
  }

  function updateGiftBar(cart) {
    var $gift = $('#sm-cart-drawer-gift');
    if (!$gift.length || !config.giftEnabled || !config.giftThreshold) {
      $gift.attr('hidden', true);
      return;
    }

    if (!cart || cart.item_count === 0) {
      $gift.attr('hidden', true);
      return;
    }

    $gift.removeAttr('hidden');

    var total = cart.total_price;
    var threshold = config.giftThreshold;
    var remaining = Math.max(threshold - total, 0);
    var progress = Math.min((total / threshold) * 100, 100);
    var qualified = remaining <= 0;
    var giftName = config.giftName || 'free gift';
    var message;

    if (qualified) {
      message = replaceTokens(config.giftQualifiedMessage, { gift: giftName });
      $gift.addClass('is-qualified');
    } else {
      message = replaceTokens(config.giftMessage, {
        amount: formatMoney(remaining),
        gift: giftName
      });
      $gift.removeClass('is-qualified');
    }

    $gift.find('[data-sm-gift-text]').text(message);
    $gift.find('[data-sm-gift-fill]').css('width', progress + '%');
  }

  function updateCartCount(cart) {
    var $count = $('[data-sm-cart-count]');
    if (!$count.length) return;

    if (!cart || cart.item_count === 0) {
      $count.attr('hidden', true).text('');
      return;
    }

    $count.removeAttr('hidden').text(cart.item_count);
  }

  function cartVariantIds(cart) {
    var ids = {};
    (cart.items || []).forEach(function (item) {
      ids[String(item.variant_id)] = true;
      ids[String(item.product_id)] = true;
    });
    return ids;
  }

  function unwrapProductGroups(args) {
    return Array.prototype.slice.call(args).map(function (result) {
      if (Array.isArray(result) && result.length >= 2 && typeof result[1] === 'string') {
        result = result[0];
      }

      if (result && result.products) {
        return result.products;
      }

      if (Array.isArray(result)) {
        return result;
      }

      return [];
    });
  }

  function normalizeProduct(product) {
    var variant = product.variants && product.variants[0];
    if (!variant) return null;

    var image = product.featured_image;
    if (!image && product.images && product.images.length) {
      image = product.images[0].src || product.images[0];
    }
    if (typeof image === 'object' && image) {
      image = image.src || image.url;
    }

    var url = product.url;
    if (!url && product.handle) {
      url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + product.handle;
    }

    return {
      id: product.id,
      title: product.title,
      url: url,
      image: image,
      price: variant.price,
      variantId: variant.id,
      available: variant.available !== false
    };
  }

  function fetchRecommendations(productId, intent) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    return $.getJSON(root + 'recommendations/products.json', {
      product_id: productId,
      limit: config.upsellLimit || 6,
      intent: intent || 'complementary'
    }).then(function (response) {
      return response && response.products ? response.products : [];
    }, function () {
      return [];
    });
  }

  function fetchCollectionProducts() {
    var handle = config.upsellCollection || 'all';
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    return $.getJSON(root + 'collections/' + handle + '/products.json', {
      limit: 30
    }).then(function (response) {
      return response && response.products ? response.products : [];
    }, function () {
      return [];
    });
  }

  function fetchCatalogProducts() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    return $.getJSON(root + 'products.json', {
      limit: 30
    }).then(function (response) {
      return response && response.products ? response.products : [];
    }, function () {
      return [];
    });
  }

  function mergeProducts(productGroups, excluded, limit) {
    var normalized = [];
    var seen = {};

    productGroups.forEach(function (group) {
      (group || []).forEach(function (product) {
        if (normalized.length >= limit) return;
        var item = normalizeProduct(product);
        if (!item || seen[item.id] || excluded[String(item.id)] || excluded[String(item.variantId)]) return;
        seen[item.id] = true;
        normalized.push(item);
      });
    });

    return normalized;
  }

  function loadUpsells(cart) {
    var requestId = ++upsellRequestId;
    var $mount = $('#sm-cart-drawer-upsell');

    if (!$mount.length || !config.upsellEnabled || !cart || cart.item_count === 0) {
      $mount.attr('hidden', true).empty();
      return;
    }

    var excluded = cartVariantIds(cart);
    var limit = config.upsellLimit || 6;
    var requests = [];

    if (config.upsellUseRecommendations && cart.items && cart.items.length) {
      cart.items.map(function (item) {
        return item.product_id;
      }).filter(function (value, index, array) {
        return array.indexOf(value) === index;
      }).slice(0, 3).forEach(function (productId) {
        requests.push(fetchRecommendations(productId, 'complementary'));
        requests.push(fetchRecommendations(productId, 'related'));
      });
    }

    requests.push(fetchCollectionProducts());
    requests.push(fetchCatalogProducts());

    $.when.apply($, requests).then(function () {
      if (requestId !== upsellRequestId) return;

      var groups = unwrapProductGroups(arguments);
      var products = mergeProducts(groups, excluded, limit);
      renderUpsell(products);
    }).fail(function () {
      if (requestId !== upsellRequestId) return;
      renderUpsell([]);
    });
  }

  function renderUpsell(products) {
    var $mount = $('#sm-cart-drawer-upsell');
    if (!$mount.length) return;

    if (!config.upsellEnabled || !products.length) {
      $mount.attr('hidden', true).empty();
      return;
    }

    $mount.removeAttr('hidden');

    var cards = products.map(function (product) {
      var image = product.image || '';
      var price = formatMoney(product.price);
      var disabled = product.available === false ? ' disabled' : '';
      var loadingClass = '';

      return (
        '<article class="sm-cart-drawer__upsell-card">' +
          '<a href="' + product.url + '" class="sm-cart-drawer__upsell-image">' +
            (image ? '<img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="96" height="96">' : '') +
          '</a>' +
          '<p class="sm-cart-drawer__upsell-name">' + product.title + '</p>' +
          '<p class="sm-cart-drawer__upsell-price">' + price + '</p>' +
          '<button type="button" class="sm-cart-drawer__upsell-add' + loadingClass + '" data-variant-id="' + product.variantId + '"' + disabled + '>Add</button>' +
        '</article>'
      );
    }).join('');

    $mount.html(
      '<div class="sm-cart-drawer__upsell-head">' +
        '<h3 class="sm-cart-drawer__upsell-title">' + (config.upsellHeading || 'You might also like') + '</h3>' +
        '<div class="sm-cart-drawer__upsell-nav">' +
          '<button type="button" data-sm-upsell-prev aria-label="Previous">‹</button>' +
          '<button type="button" data-sm-upsell-next aria-label="Next">›</button>' +
        '</div>' +
      '</div>' +
      '<div class="sm-cart-drawer__upsell-track" data-sm-upsell-track>' + cards + '</div>'
    );

    bindUpsellNav($mount);
  }

  function bindUpsellNav($mount) {
    var $track = $mount.find('[data-sm-upsell-track]');
    var $prev = $mount.find('[data-sm-upsell-prev]');
    var $next = $mount.find('[data-sm-upsell-next]');

    function updateNav() {
      if (!$track.length) return;
      var maxScroll = $track[0].scrollWidth - $track[0].clientWidth;
      $prev.prop('disabled', $track.scrollLeft() <= 4);
      $next.prop('disabled', $track.scrollLeft() >= maxScroll - 4);
    }

    $prev.on('click', function () {
      $track.animate({ scrollLeft: $track.scrollLeft() - 104 }, 220);
    });

    $next.on('click', function () {
      $track.animate({ scrollLeft: $track.scrollLeft() + 104 }, 220);
    });

    $track.on('scroll', updateNav);
    updateNav();
  }

  // Discounted line prices
  // The theme's cart template mislabels discounted lines (it crosses out the
  // discounted price and leaves the "now" price blank). This rewrites the
  // price area of each line from Shopify's own cart data:
  //   discounted line  -> ~~was~~ / now
  //   normal line      -> price (left as the theme drew it)
  // Lines are matched to the cart data by their key / variant id, never by
  // position, so adding or removing items can't put prices on the wrong row.

  var PRICE_STYLE_WRAP = 'display:flex !important; flex-direction:column !important; align-items:flex-end !important; justify-content:center !important; gap:2px !important; text-align:right !important;';
  var PRICE_STYLE_WAS = 'position:static !important; display:block !important; white-space:nowrap !important; font-size:13px !important; line-height:1.2 !important; color:#767676 !important; margin:0 !important;';
  var PRICE_STYLE_NOW = 'position:static !important; display:block !important; white-space:nowrap !important; line-height:1.2 !important; margin:0 !important;';

  function lineFinalPrice(item) {
    var original = item.original_line_price;
    var finalPrice = item.final_line_price;

    if (typeof finalPrice !== 'number') {
      finalPrice = original;
    }

    if (finalPrice >= original && item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      var allocated = item.line_level_discount_allocations.reduce(function (sum, allocation) {
        return sum + (allocation.amount || 0);
      }, 0);
      finalPrice = original - allocated;
    }

    return Math.max(finalPrice, 0);
  }

  function findItemForRow($row, cart) {
    var ids = [];
    $row.find('[data-id]').each(function () {
      var value = $(this).attr('data-id');
      if (value) ids.push(String(value));
    });
    if (!ids.length) return null;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var candidates = [item.key, item.id, item.variant_id].map(String);
      for (var j = 0; j < ids.length; j++) {
        if (candidates.indexOf(ids[j]) !== -1) return item;
      }
    }
    return null;
  }

  function updateDiscountedPrices(cart) {
    if (!cart || !cart.items) return;

    $('#CartContainer .ajaxcart__row').each(function (index) {
      var $row = $(this);
      var $prices = $row.find('.sm-cart-drawer__item-prices');
      if (!$prices.length) return;

      var item = findItemForRow($row, cart);
      // Fall back to position only if the counts line up exactly
      if (!item && $('#CartContainer .ajaxcart__row').length === cart.items.length) {
        item = cart.items[index];
      }
      if (!item || typeof item.original_line_price !== 'number') return;

      var original = item.original_line_price;
      var finalPrice = lineFinalPrice(item);
      var key = item.key + ':' + original + ':' + finalPrice;
      if ($prices.attr('data-sm-price-fixed') === key) return;

      if (finalPrice < original) {
        $prices
          .attr('data-sm-price-fixed', key)
          .attr('style', PRICE_STYLE_WRAP)
          .html(
            '<span class="sm-cart-drawer__item-price--was" style="' + PRICE_STYLE_WAS + '"><s>' + formatMoney(original) + '</s></span>' +
            '<span class="sm-cart-drawer__item-price ajaxcart-item__price" style="' + PRICE_STYLE_NOW + '">' + formatMoney(finalPrice) + '</span>'
          );
      } else {
        $prices
          .attr('data-sm-price-fixed', key)
          .attr('style', PRICE_STYLE_WRAP)
          .html('<span class="sm-cart-drawer__item-price ajaxcart-item__price" style="' + PRICE_STYLE_NOW + '">' + formatMoney(original) + '</span>');
      }
    });
  }

  // Always use fresh cart data from Shopify (never an older copy).
  var refreshTimer = null;
  function refreshDiscountedPrices() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      $.getJSON('/cart.js').done(updateDiscountedPrices);
    }, 80);
  }

  // Re-apply whenever the drawer redraws (adding items, quantity changes,
  // reopening). Watches the whole drawer in case the item list is replaced.
  var priceObserver = null;
  function watchCartContainer() {
    var target = document.getElementById('CartDrawer') || document.getElementById('CartContainer');
    if (!target || priceObserver || !window.MutationObserver) return;

    priceObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var node = mutations[i].target;
        // Ignore changes we made ourselves inside a price area
        if (node && node.closest && node.closest('[data-sm-price-fixed]')) continue;
        refreshDiscountedPrices();
        return;
      }
    });
    priceObserver.observe(target, { childList: true, subtree: true });
  }

  // Free gift auto-add
  // When the cart reaches the "Minimum cart total" setting, the Gift product
  // (e.g. the tote) is added to the cart. If the cart drops back under, it is
  // taken out again. The automatic Buy X Get Y discount in Shopify is what
  // makes it free; this only puts it in the cart so it shows on the order and
  // packing slip.
  //   - The gift itself doesn't count towards the minimum.
  //   - Only ever 1 gift.
  //   - If the customer removes the gift, it isn't added back this visit
  //     (until they drop under and go over again).

  var giftBusy = false;
  var giftLast = null;
  var giftFailed = false;

  function giftStore(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, value);
    } catch (error) {}
    return null;
  }

  function giftVariantId() {
    var id = config.giftVariantId;
    if (id) return $.Deferred().resolve(String(id)).promise();

    var handle = config.giftProductHandle;
    if (!handle) return $.Deferred().resolve(null).promise();

    return $.getJSON('/products/' + handle + '.js').then(function (product) {
      var variant = product && product.variants && (product.variants.filter(function (v) { return v.available; })[0] || product.variants[0]);
      config.giftVariantId = variant ? variant.id : null;
      return config.giftVariantId ? String(config.giftVariantId) : null;
    }, function () {
      return null;
    });
  }

  function reloadCart() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    } else if (window.ajaxCart && ajaxCart.load) {
      ajaxCart.load();
    } else if (window.ShopifyAPI && ShopifyAPI.getCart) {
      ShopifyAPI.getCart(onCartLoaded);
    }
  }

  function changeLine(key, quantity) {
    return $.ajax({ type: 'POST', url: '/cart/change.js', data: { id: key, quantity: quantity }, dataType: 'json' });
  }

  function syncFreeGift(cart) {
    if (giftBusy || giftFailed || !cart || !cart.items) return;
    if (!config.giftEnabled || !config.giftAutoAdd || !config.giftThreshold) return;

    giftVariantId().then(function (variantId) {
      if (!variantId || giftBusy) return;

      var giftLines = [];
      var otherItems = 0;
      var qualifyingTotal = 0;

      cart.items.forEach(function (item) {
        if (String(item.variant_id) === variantId) {
          giftLines.push(item);
        } else {
          otherItems += item.quantity;
          qualifyingTotal += lineFinalPrice(item);
        }
      });

      var qualified = otherItems > 0 && qualifyingTotal >= config.giftThreshold;
      var giftQty = giftLines.reduce(function (sum, item) { return sum + item.quantity; }, 0);

      if (!giftLast) {
        try { giftLast = JSON.parse(giftStore('smGiftLast') || 'null'); } catch (error) { giftLast = null; }
      }
      // Customer took the gift out themselves while still qualifying
      if (giftLast && giftLast.qualified && giftLast.giftQty > 0 && qualified && giftQty === 0) {
        giftStore('smGiftDeclined', '1');
      }
      // Dropped under the minimum: forget the "declined" choice
      if (!qualified) giftStore('smGiftDeclined', null);
      giftLast = { qualified: qualified, giftQty: giftQty };
      giftStore('smGiftLast', JSON.stringify(giftLast));

      var request = null;

      if (qualified && giftQty === 0 && giftStore('smGiftDeclined') !== '1') {
        request = $.ajax({ type: 'POST', url: '/cart/add.js', data: { id: variantId, quantity: 1 }, dataType: 'json' });
      } else if (!qualified && giftQty > 0) {
        request = changeLine(giftLines[0].key, 0);
      } else if (qualified && giftQty > 1) {
        request = changeLine(giftLines[0].key, 1);
      }

      if (!request) return;

      giftBusy = true;
      request.done(function () {
        giftBusy = false;
        reloadCart();
      }).fail(function () {
        // e.g. gift out of stock: stop trying for this page view
        giftBusy = false;
        giftFailed = true;
      });
    });
  }

  function onCartLoaded(_event, cart) {
    updateCartCount(cart);
    watchCartContainer();
    refreshDiscountedPrices();
    updateGiftBar(cart);
    loadUpsells(cart);
    syncFreeGift(cart);
  }

  function onUpsellAdd(event) {
    var $button = $(event.currentTarget);
    var variantId = $button.data('variant-id');
    if (!variantId || $button.prop('disabled')) return;

    $button.addClass('is-loading').text('Adding…');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json'
    }).done(function () {
      if (window.ajaxCart && ajaxCart.load) {
        ajaxCart.load();
      } else {
        ShopifyAPI.getCart(onCartLoaded);
      }
    }).fail(function () {
      $button.removeClass('is-loading').text('Add');
    });
  }

  function bindEvents() {
    $(document.body)
      .on('afterCartLoad.ajaxCart', onCartLoaded)
      .on('click', '.sm-cart-drawer__upsell-add', onUpsellAdd);
  }

  function init() {
    config = readConfig();
    bindEvents();
    watchCartContainer();
    refreshDiscountedPrices();
    // Also check on page load (e.g. the full cart page, or items added elsewhere)
    $.getJSON('/cart.js').done(syncFreeGift);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(jQuery);